import ChecklistReportNotApplicableComponent, {
  ChecklistReportNotConformComponentProps,
} from './ChecklistReportNotConformComponent';

export default ChecklistReportNotApplicableComponent;

export type { ChecklistReportNotConformComponentProps };
